<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="md_code,pr_detail"
      placeholder="输入拆解单号、物料进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/production/disassemble/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.pr_detail}}</p>
          <p class="list-item-muted">{{item.createTime}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.md_code}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.md_status!='已审核'}"
          >{{item.md_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}张</label>
    </div>
    <add-button to="/production/disassemble_edit" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/make/makeDisassemble/list",
      params: {
        caller: "MakeDisassemble"
      },
      filters: [
        {
          type: "date",
          name: "make_disassemble.createTime"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              mode: "MAIN"
            },
            {
              value: 1,
              label: "待领料",
              condition:
                "md_tasktype='MAKEDISASSEMBLE' and md_statuscode='AUDITED' and ifnull(md_getstatus,'未领料') in('未领料','部分领料') and exists(select 1 from make_disassemble where  md_qty-ifnull(md_havegetqty,0)-ifnull(md_turngetqty,0)>0)"
            },
            {
              value: 2,
              label: "待检验",
              mode: "DETAIL",
              condition:
                "md_tasktype='MAKEDISASSEMBLE' and md_statuscode='AUDITED' and md_getstatus != '未领料' and (((ifnull(dd_inqty,0)+ifnull(dd_turnqty,0))/dd_oneuseqty) < md_havegetqty)"
            },
            {
              value: 3,
              label: "已完工",
              condition: "md_tasktype='MAKEDISASSEMBLE' AND md_finishstatus='已完工'"
            },
            {
              value: 4,
              label: "已结案",
              condition: "md_tasktype='MAKEDISASSEMBLE' AND md_statuscode='END'"
            }
          ]
        }
      ]
    };
  }
};
</script>